import React, { memo, useMemo } from 'react';

import { TableCell, TableRow, Tooltip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { InfoIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';
import { SlaType } from 'constants/slaGroups';

import { columns, SlaInfoTableColumnIdsEnum } from './TaskSlaGroupInfoTable.constants';

const getStyles = (theme, { isActive }) => ({
  tableRowColor: {
    backgroundColor: isActive ? theme.palette.success.main : null,
  },
  deletedUser: {
    color: theme.palette.error.main,
  },
  infoIcon: {
    verticalAlign: 'super',
  },
});

const disablePortalProp = { disablePortal: true };

const renderTableData = ({ id, level, classes }) => {
  switch (id) {
    case SlaInfoTableColumnIdsEnum.POTENTIAL_ASSIGNEES:

    case SlaInfoTableColumnIdsEnum.ASSIGNED_USERS: {
      return level[id]?.map(({ fullName, userId, isDeleted }, index) => (
        <span className={isDeleted ? classes.deletedUser : ''} key={userId}>
          {fullName}
          {isDeleted && ' (deleted)'}
          {index < level[id].length - 1 && ', '}
        </span>
      ));
    }

    case SlaInfoTableColumnIdsEnum.DURATION_HOURS: {
      return `${level.duration.duration} ${
        level.duration.type === SlaType.REGULAR_HOURS ? 'Hours' : 'Days'
      }`;
    }

    case SlaInfoTableColumnIdsEnum.ASSIGNMENT_TYPE: {
      const info = level.assignmentTypeInfo;

      return (
        <>
          {level[id]}
          {!!info && (
            <Tooltip
              PopperProps={disablePortalProp}
              placement="top"
              sx={classes.infoIcon}
              title={info}
            >
              <span>
                <InfoIcon size={IconSize[16]} />
              </span>
            </Tooltip>
          )}
        </>
      );
    }

    default:
      return level[id];
  }
};

const TaskSlaGroupInfoTableItem = ({ level }) => {
  const { isActive, id } = level;
  const theme = useTheme();
  const classes = useMemo(() => getStyles(theme, { isActive }), [theme, isActive]);

  return (
    <TableRow data-testid={id} sx={classes.tableRowColor}>
      {columns.map(({ id, align, className }) => (
        <TableCell align={align} className={className} key={id}>
          {renderTableData({ id, level, classes })}
        </TableCell>
      ))}
    </TableRow>
  );
};

TaskSlaGroupInfoTableItem.propTypes = {
  level: PropTypes.object.isRequired,
};

export default memo(TaskSlaGroupInfoTableItem);
